module.exports = __webpack_public_path__ + "static/img/3caca.d280831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/3caca.png
// module id = 211
// module chunks = 1